import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { HeartbeatIcon } from 'ui';
import { type ActivityTodo } from '../../../../types';
import { BaseTodoWidgetItem } from '../BaseTodoWidgetItem';

type P = {
  type?: ComponentProps<typeof BaseTodoWidgetItem>['type'];
  todo: ActivityTodo;
  className?: string;
};

const ActivityTodoWidgetItem = ({ type, todo, className }: P) => {
  const { t } = useTranslation();

  const titles = {
    annually: t('Complete your annual activity'),
    daily: t('Complete your daily activity'),
    monthly: t('Complete your monthly activity'),
    quarterly: t('Complete your quarterly activity'),
    weekly: t('Complete your weekly activity'),
  } as const;

  return (
    <BaseTodoWidgetItem
      type={type}
      className={className}
      path={todo.path}
      icon={<HeartbeatIcon />}
      title={titles[todo.activity.periodicityType] ?? t('Complete the activity')}
      description={todo.activity.name}
      additionalDescription={todo.activity.description}
      startTime={todo.startTime}
      endTime={todo.endTime}
      hasInProgressStatus={todo.activity.periodicityType === 'daily' && todo.activity.times.length > 0}
    />
  );
};

export default ActivityTodoWidgetItem;
